module.exports = __webpack_public_path__ + "media/images/landing/our_work_bg-b84bd621cda6d2c78dcdf0513aaea029.jpg";